module.exports = LIBS["react-dom"];